import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import InfluencerForm from '@/components/InfluencerForm';
import Footer from '@/components/Footer';

const InfluencerFormPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen bg-black text-white">
      <Navbar />
      <div className="relative z-10 pt-32">
        <InfluencerForm />
      </div>
      <Footer />
    </div>
  );
};

export default InfluencerFormPage;
